export default [
    { //通知公告管理
        path: '/partnerManagement/notice',
        name:'partnerManagementNotice',
        meta: { title: '通知公告管理'},
        component: () => import('../../views/partnerManagement/notice.vue')
    },
    { //通知公告详情
        path: '/partnerManagement/notice/detail/:id',
        name:'partnerManagementNoticeDetail',
        meta: { title: '通知公告详情'},
        component: () => import('../../views/partnerManagement/noticeDetail.vue')
    },
    { //添加通知公告
      path: '/partnerManagement/notice/add',
      name:'partnerManagementNoticeAdd',
      meta: { title: '添加通知公告'},
      component: () => import('../../views/partnerManagement/noticeAdd.vue')
   },
   { //编辑通知公告
    path: '/partnerManagement/notice/edit/:id',
    name:'partnerManagementNoticeEdit',
    meta: { title: '编辑通知公告'},
    component: () => import('../../views/partnerManagement/noticeEdit.vue')
 },
    { //协会动态管理
      path: '/partnerManagement/association',
      name:'partnerManagementAssociation',
      meta: { title: '协会动态管理'},
      component: () => import('../../views/partnerManagement/association.vue')
    },
    { //协会动态详情
      path: '/partnerManagement/association/detail/:id',
      name:'partnerManagementAssociationDetail',
      meta: { title: '协会动态详情'},
      component: () => import('../../views/partnerManagement/associationDetail.vue')
    },
    { //添加协会动态
      path: '/partnerManagement/association/add',
      name:'partnerManagementAssociationAdd',
      meta: { title: '添加协会动态'},
      component: () => import('../../views/partnerManagement/associationAdd.vue')
   },
   { //编辑协会动态
    path: '/partnerManagement/association/edit/:id',
    name:'partnerManagementAssociationEdit',
    meta: { title: '编辑协会动态'},
    component: () => import('../../views/partnerManagement/associationEdit.vue')
 },
    { //附件资料管理
      path: '/partnerManagement/enclosure',
      name:'partnerManagementEnclosure',
      meta: { title: '协会动态管理'},
      component: () => import('../../views/partnerManagement/enclosure.vue')
    },
    { //附件资料详情
      path: '/partnerManagement/enclosure/detail/:id',
      name:'partnerManagementEnclosureDetail',
      meta: { title: '协会动态详情'},
      component: () => import('../../views/partnerManagement/enclosureDetail.vue')
    },
    { //添加附件资料
      path: '/partnerManagement/enclosure/add',
      name:'partnerManagementEnclosureAdd',
      meta: { title: '添加附件资料'},
      component: () => import('../../views/partnerManagement/enclosureAdd.vue')
   },
   { //编辑附件资料
    path: '/partnerManagement/enclosure/edit/:id',
    name:'partnerManagementEnclosureEdit',
    meta: { title: '编辑附件资料'},
    component: () => import('../../views/partnerManagement/enclosureEdit.vue')
 },
 { //会员单位管理
  path: '/partnerManagement/memberUnit',
  name:'partnerManagementMemberUnit',
  meta: { title: '会员单位管理'},
  component: () => import('../../views/partnerManagement/memberUnit.vue')
},
{ //编辑会员单位
  path: '/partnerManagement/memberUnit/edit/:id?',
  name:'partnerManagementMemberUnitEdit',
  meta: { title: '编辑会员单位'},
  component: () => import('../../views/partnerManagement/memberUnitEdit.vue')
},
{ //会员单位详情
  path: '/partnerManagement/memberUnit/detail/:id',
  name:'partnerManagementMemberUnitDetail',
  meta: { title: '会员单位详情'},
  component: () => import('../../views/partnerManagement/memberUnitDetail.vue')
},
{ //会员服务管理
  path: '/partnerManagement/memberServices',
  name:'partnerManagementMemberServices',
  meta: { title: '会员服务管理'},
  component: () => import('../../views/partnerManagement/memberServices.vue')
},
{ //会员风采管理
  path: '/partnerManagement/memberStyle',
  name:'partnerManagementMemberStyle',
  meta: { title: '会员风采管理'},
  component: () => import('../../views/partnerManagement/memberStyle.vue')
},
{ //员风采详情
  path: '/partnerManagement/memberStyle/detail/:id',
  name:'partnerManagementMemberStyleDetail',
  meta: { title: '员风采详情'},
  component: () => import('../../views/partnerManagement/memberStyleDetail.vue')
},
{ //添加员风采
path: '/partnerManagement/memberStyle/add',
name:'partnerManagementMemberStyleAdd',
meta: { title: '添加员风采'},
component: () => import('../../views/partnerManagement/memberStyleAdd.vue')
},
{ //编辑员风采
path: '/partnerManagement/memberStyle/edit/:id',
name:'partnerManagementMemberStyleEdit',
meta: { title: '编辑员风采'},
component: () => import('../../views/partnerManagement/memberStyleEdit.vue')
},
{ //协会简介管理
  path: '/partnerManagement/associationInfo',
  name:'partnerManagementAssociationInfo',
  meta: { title: '协会简介管理'},
  component: () => import('../../views/partnerManagement/associationInfo.vue')
},
]